let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: "充电桩显示名称",
    props: "showName",
    minWidth: 200,
  },
  {
    label: "充电桩类型",
    props: "chargingPileType",
    minWidth: 200,
    formatter: (row) => {
      if (row.chargingPileType == "WALL_MOUNTED") {
        return "壁挂式";
      } else if (row.chargingPileType == "PORTABLE") {
        return "便携式";
      } else if (row.chargingPileType == "WULING") {
        return "五菱桩";
      } else {
        return "";
      }
    },
  },
  {
    label: "充电桩型号",
    props: "pileTypeName",
    minWidth: 200,
  },
  {
    label: "充电桩编号",
    props: "pileNo",
    minWidth: 200,
  },
  {
    label: "充电桩IMEI编号",
    props: "pileCode",
    minWidth: 200,
  },
  {
    label: "成品料号",
    props: "materialNo",
    minWidth: 200,
  },
  // 23-06-02 添加
  {
    label: "充电桩实时状态",
    props: "pileStatusName",
    minWidth: 200,
  },
  {
    label: "绑定渠道",
    props: "bindChannelName",
    minWidth: 200,
  },
  {
    label: "是否开通共享",
    props: "shareActive",
    minWidth: 200,
    formatter: (row) => {
      if (row.shareActive == "1") {
        return "开通";
      } else if (row.shareActive == "0") {
        return "未开通";
      } else {
        return "";
      }
    },
  },
  {
    label: "开通共享时间",
    props: "openShareActiveTime",
    minWidth: 200,
  },
  {
    label: " 当前共享状态",
    props: "shareModeName",
    minWidth: 200,
  },
  {
    label: "当前共享平台服务费（元）",
    props: "localServFee",
    minWidth: 200,
  },
  {
    label: "当前服务费生效时间",
    props: "localServFeeStartTime",
    minWidth: 200,
  },
  {
    label: "当前服务费到期时间",
    props: "localServFeeEndTime",
    minWidth: 200,
  },
  {
    label: "厂商代码",
    props: "manufactureMark",
    minWidth: 200,
    sortable: true,
  },
  {
    label: "软件版本",
    props: "softVersion",
    minWidth: 200,
  },
  {
    label: "支持协议",
    props: "latestChargeDate",
    minWidth: 200,
    formatter: (row) => {
      return "桩到家协议";
    },
  },
  {
    label: "电流输出类型",
    props: "currentOutType",
    minWidth: 200,
    formatter: (row) => {
      return row.currentOutType == "01"
        ? "交流"
        : row.currentOutType == "02"
        ? "直流"
        : "";
    },
  },
  {
    label: "单项桩/三项桩",
    props: "phaseTypeName",
    minWidth: 200,
  },
  {
    label: "功率",
    props: "ratedPower",
    minWidth: 200,
  },
  {
    label: "所属用户",
    props: "userPhone",
    minWidth: 200,
  },
  {
    label: "绑定时间",
    props: "bindTime",
    minWidth: 200,
  },
];

// 列表展示项
pageConfig.reservationListColumns = [
  {
    label: "预约策略",
    props: "remark",
    minWidth: 200,
  },
  {
    label: "预约来源",
    props: "bindSource",
    minWidth: 300,
    tooltip: true,
  },
  {
    label: "预约用户",
    props: "custPhone",
    minWidth: 200,
  },
  {
    label: "创建时间",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "生效状态",
    props: "onoff",
    minWidth: 200,
    formatter: function (row) {
      return "生效";
    },
  },
];

// 列表展示项
pageConfig.custDetailColumns = [
  {
    label: "操作时间",
    props: "lastModifiedWhen",
    minWidth: 200,
  },
  {
    label: "充值金额（元）",
    props: "inExpAmount",
    minWidth: 200,
    tooltip: true,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.operateType == "01") {
        return row.inExpAmount;
      } else {
        return "";
      }
    },
  },
  {
    label: "退款金额（元）",
    props: "inExpAmount",
    minWidth: 200,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.operateType == "07") {
        return row.inExpAmount;
      } else {
        return "";
      }
    },
  },
  {
    label: "账户剩余金额（元）",
    props: "changeFreeBal",
    minWidth: 200,
  },
  {
    label: "操作人",
    props: "lastModifiedByName",
    minWidth: 200,
  },
  {
    label: "备注",
    props: "remark",
    minWidth: 200,
  },
];

// 列表展示项
pageConfig.faultDetailColumns = [
  {
    label: "通知类型",
    props: "statusTypeName",
    minWidth: 200,
    formatter: function (row) {
      return "故障";
    },
  },
  {
    label: "故障状态",
    props: "pileStatusName",
    minWidth: 200,
  },
  {
    label: "备注",
    props: "remark",
    minWidth: 200,
  },
  {
    label: "时间",
    props: "createdWhen",
    minWidth: 200,
  },
];

// 报文日志列表
pageConfig.logListColumns = [
  {
    label: "充电桩IMEI码",
    props: "rcsCode",
    minWidth: 200,
  },
  {
    label: "方向",
    props: "messageTypeName",
    minWidth: 200,
  },
  {
    label: "第一条消息类型名称",
    props: "firstMessageTypeName",
    minWidth: 200,
  },
  {
    label: "第二条消息类型名称",
    props: "secondMessageTypeName",
    minWidth: 200,
  },
  {
    label: "时间",
    props: "createdWhen",
    minWidth: 200,
  },
];
// 报文日志列表
pageConfig.updateListColumns = [
  {
    label: "充电桩IMEI码",
    props: "pileNo",
    minWidth: 200,
  },
  {
    label: "升级任务名称",
    props: "versionDesc",
    minWidth: 200,
  },
  {
    label: "升级版本名称",
    props: "versionDesc",
    minWidth: 200,
  },
  {
    label: "升级版本号",
    props: "currentVersionNo",
    minWidth: 200,
  },
  {
    label: "升级前版本号",
    props: "versionId",
    minWidth: 200,
  },
  {
    label: "升级状态",
    props: "upgradeStatus",
    minWidth: 200,
  },
  {
    label: "版本更新内容",
    props: "versionDesc",
    minWidth: 200,
  },
  {
    label: "计划升级时间",
    props: "upgradeStartTime",
    minWidth: 200,
  },
  {
    label: "升级完成时间",
    props: "upgradeEndTime",
    minWidth: 200,
  },
];

// // 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "title",
    name: "充电桩设备列表",
  },
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: false,
};
// 列表-表格属性
pageConfig.noSeltableConfig = {
  showSelection: false,
  showIndex: false,
};

// dialog列表-表格属性
pageConfig.dialogTableConfig = {
  showSelection: false,
  showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};

// 列表-分页参数
pageConfig.detailPagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};
// 车辆信息 - 分页参数
pageConfig.carPagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};
// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: "id",
  editRouter: "pileModelDetail",
};

// 路由
pageConfig.listRouter = "pileList";

// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: " 充电桩设备列表",
    router: "pileList",
  },
  {
    type: "title",
    name: "详情",
  },
];

pageConfig.formRules = {
  pileTypeName: [
    {
      required: true,
      message: "请填写充电桩型号名称",
      trigger: "blur",
    },
  ],
};

pageConfig.labelFormRules = {
  configName: [
    {
      required: true,
      message: "请填写标签名称",
      trigger: "blur",
    },
  ],
  configVal: [
    {
      required: true,
      message: "请填写编号",
      trigger: "blur",
    },
  ],
};

pageConfig.dealerFormRules = {
  dealerNo: [
    {
      required: true,
      message: "请填写运营商全称",
      trigger: "blur",
    },
  ],
  mobile: [
    {
      required: true,
      message: "请填写客户手机号",
      trigger: "blur",
    },
    {
      pattern:
        /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
      message: "手机号填写错误",
      trigger: "blur",
    },
  ],
};

pageConfig.selectFormRules = {
  remark: [
    {
      required: true,
      message: "请填写备注",
      trigger: "blur",
    },
  ],
  chargeValue: [
    {
      required: true,
      message: "请输入充值度电",
      trigger: "blur",
    },
  ],
};

pageConfig.remarkFormRules = {
  remark: [
    {
      required: true,
      message: "请填写备注",
      trigger: "blur",
    },
  ],
};

export default pageConfig;
